import { FirearmAssignmentService } from './firearm-assignment.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FIREARM_ASSIGNMENT_TYPE, FirearmAssignment } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class FirearmAssignmentResolverBase implements Resolve<FirearmAssignment> {

  constructor(protected service: FirearmAssignmentService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FirearmAssignment> {
    const key: number = FIREARM_ASSIGNMENT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



